import { render, staticRenderFns } from "./CharityReleaseForm.vue?vue&type=template&id=624d773e&scoped=true&"
import script from "./CharityReleaseForm.vue?vue&type=script&lang=js&"
export * from "./CharityReleaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CharityReleaseForm.vue?vue&type=style&index=0&id=624d773e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d773e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
